// تشخیص دستگاه برای رفتارهای مخصوص موبایل

const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";

// iPhone / iPad (آیپدهای جدید خودشان را «Mac» معرفی می‌کنند)
export const isIOS =
  /iPad|iPhone|iPod/.test(ua) ||
  (typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// برنامه از روی «افزودن به صفحه اصلی» (PWA) باز شده است
export const isStandalone =
  typeof window !== "undefined" &&
  ((window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true);

// صفحه لمسی (گوشی / تبلت)
export const isTouch =
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(hover: none) and (pointer: coarse)").matches
    : false;

/**
 * فوکوس خودکار روی اینپوت‌ها:
 * - در آیفون (سافاری و PWA) و در هر PWA لمسی غیرفعال است؛ چون کیبورد ناگهانی بالا می‌آید،
 *   صفحه می‌پرد و صفحه زیر کیبورد می‌رود.
 * - روی کامپیوتر فعال می‌ماند.
 */
export const AUTO_FOCUS = !(isIOS || (isStandalone && isTouch));
